import React, { useState, useRef, useEffect } from "react";
import QRCodeStyling from "qr-code-styling";
import JSZip from "jszip";
import { RiResetLeftFill } from "react-icons/ri";
import { FaChevronDown, FaPlus, FaDownload, FaTrash } from "react-icons/fa";
import { MdOutlineImageNotSupported } from "react-icons/md";
import bg from '../assets/images/bg.webp';
import logomyH from '../assets/images/logonMyh.png';
import { logoOptions } from '../components/donvi';

const pageStyles = {
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
  backgroundImage: `url(${bg})`, 
  minHeight: "90vh", 
  backgroundPosition: 'center', 
  backgroundSize: 'cover'
};

export default function CreateMultiQR() {
  const [isformatStyleQR, setIsformatStyleQR] = useState(false);
  const [isformatColorQR, setIsformatColorQR] = useState(false);
  const [isformatLogoQR, setIsformatLogoQR] = useState(false);
  const [inputMode, setInputMode] = useState('range'); // 'range' or 'list'
  const [fromNum, setFromNum] = useState('');
  const [toNum, setToNum] = useState('');
  const [inputData, setInputData] = useState('');
  const [qrCodes, setQrCodes] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);

  const fileInputRef = useRef(null);
  const qrContainerRef = useRef(null);

  const valueSelectStyleQR = [
    { value: "square", label: "Vuông" },
    { value: "classy", label: "Thanh lịch" },
    { value: "classy-rounded", label: "Bo tròn thanh lịch" },
    { value: "dots", label: "Nhiều chấm" },
    { value: "dot", label: "Chấm" },
    { value: "rounded", label: "Bo tròn" },
    { value: "extra-rounded", label: "Bo tròn đặc biệt" },
  ];

  const [settings, setSettings] = useState(() => {
    const savedSettings = localStorage.getItem("multiQrSettings");
    return savedSettings
      ? JSON.parse(savedSettings)
      : {
          width: 300,
          height: 300,
          type: "png",
          shape: "square",
          image: logomyH,
          margin: 1,
          dotsOptionsColor: "#000000",
          dotsOptionsType: "dots",
          backgroundOptionsColor: "#ffffff",
          cornersSquareOptionsType: "extra-rounded",
          cornersSquareOptionsColor: "#000000",
          cornersDotOptionsType: "extra-rounded",
          cornersDotOptionsColor: "#000000",
          imageOptions_crossOrigin: "anonymous",
          imageOptions_margin: 1,
        };
  });

  const handleChange = (field, value) => {
    const newSettings = { ...settings, [field]: value };
    setSettings(newSettings);
    localStorage.setItem("multiQrSettings", JSON.stringify(newSettings));
  };

  const generateQRCodes = () => {
    setIsGenerating(true);
    let dataList = [];
    
    if (inputMode === 'range') {
      const from = parseInt(fromNum, 10);
      const to = parseInt(toNum, 10);
      
      if (isNaN(from) || isNaN(to)) {
        alert("Vui lòng nhập số hợp lệ!");
        setIsGenerating(false);
        return;
      }
      
      if (from > to) {
        alert("Số bắt đầu phải nhỏ hơn hoặc bằng số kết thúc!");
        setIsGenerating(false);
        return;
      }
      
      if (to - from > 1000) {
        alert("Không thể tạo quá 1000 QR code trong một lần!");
        setIsGenerating(false);
        return;
      }
      
      // Tạo mảng số từ from đến to
      for (let i = from; i <= to; i++) {
        dataList.push(i.toString());
      }
    } else {
      // Chế độ nhập danh sách cách nhau bởi dấu phẩy
      dataList = inputData.split(",").map(s => s.trim()).filter(Boolean);
      
      if (dataList.length === 0) {
        alert("Vui lòng nhập nội dung, cách nhau bởi dấu phẩy");
        setIsGenerating(false);
        return;
      }
    }

    const newQrCodes = [];
    
    dataList.forEach((data, index) => {
      const qrCode = new QRCodeStyling({
        width: settings.width,
        height: settings.height,
        type: settings.type,
        shape: settings.shape,
        data: data,
        image: settings.image,
        margin: settings.margin,
        dotsOptions: { 
          color: settings.dotsOptionsColor, 
          type: settings.dotsOptionsType 
        },
        backgroundOptions: { 
          color: settings.backgroundOptionsColor 
        },
        cornersSquareOptions: { 
          type: settings.cornersSquareOptionsType, 
          color: settings.cornersSquareOptionsColor 
        },
        cornersDotOptions: { 
          type: settings.cornersDotOptionsType, 
          color: settings.cornersDotOptionsColor 
        },
        imageOptions: { 
          crossOrigin: "anonymous", 
          margin: settings.imageOptions_margin 
        }
      });

      newQrCodes.push({
        qrCode,
        data,
        id: Date.now() + index
      });
    });

    setQrCodes(newQrCodes);
    setIsGenerating(false);
  };

  const downloadSingleQR = async (qrCode, filename) => {
    try {
      const blob = await qrCode.getRawData("png");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading QR:", error);
      alert("Lỗi khi tải QR code");
    }
  };

  const downloadAllQR = async () => {
    if (qrCodes.length === 0) {
      alert("Chưa có QR code nào để tải xuống");
      return;
    }

    try {
      const zip = new JSZip();
      
      for (const { qrCode, data } of qrCodes) {
        const pngBlob = await qrCode.getRawData("png");
        const sanitizedFilename = data.replace(/[^a-zA-Z0-9]/g, '_');
        zip.file(`${sanitizedFilename}.png`, pngBlob);
      }
      
      const content = await zip.generateAsync({ type: "blob" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(content);
      link.download = "qr_codes.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error creating zip:", error);
      alert("Lỗi khi tạo file ZIP");
    }
  };

  const clearAllQR = () => {
    setQrCodes([]);
    setInputData('');
    setFromNum('');
    setToNum('');
  };

  // Render QR codes when they change
  useEffect(() => {
    if (qrCodes.length > 0 && qrContainerRef.current) {
      qrContainerRef.current.innerHTML = '';
      
      qrCodes.forEach(({ qrCode, data, id }) => {
        const container = document.createElement("div");
        container.className = "qr-item bg-white p-4 rounded-lg shadow-md";
        container.style.display = "inline-block";
        container.style.margin = "10px";
        container.style.textAlign = "center";

        const qrDiv = document.createElement("div");
        container.appendChild(qrDiv);
        qrCode.append(qrDiv);

        const label = document.createElement("p");
        label.textContent = data;
        label.className = "mt-2 text-sm font-medium text-gray-700 break-words";
        label.style.maxWidth = `${settings.width}px`;
        container.appendChild(label);

        const btnDiv = document.createElement("div");
        btnDiv.className = "mt-2 flex gap-2 justify-center";

        const downloadBtn = document.createElement("button");
        downloadBtn.textContent = "Tải xuống";
        downloadBtn.className = "px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600 transition-colors";
        downloadBtn.onclick = () => downloadSingleQR(qrCode, data);
        btnDiv.appendChild(downloadBtn);

        container.appendChild(btnDiv);
        qrContainerRef.current.appendChild(container);
      });
    }
  }, [qrCodes, settings.width]);

  return (
    <div style={pageStyles}>
      <div className="p-6 max-w-7xl mx-auto flex flex-col lg:flex-row gap-6">
        {/* Cột bên trái - Chỉnh thông tin */}
        <div className="lg:w-1/3 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-center mb-4 text-[#0266B4]">Tạo nhiều mã QR</h2>
          
          {/* Chế độ nhập liệu */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Chế độ nhập</label>
            <div className="flex gap-2">
              <button
                onClick={() => setInputMode('range')}
                className={`flex-1 px-3 py-2 text-sm rounded transition-colors ${
                  inputMode === 'range'
                    ? 'bg-[#0266B4] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Khoảng số
              </button>
              <button
                onClick={() => setInputMode('list')}
                className={`flex-1 px-3 py-2 text-sm rounded transition-colors ${
                  inputMode === 'list'
                    ? 'bg-[#0266B4] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Danh sách
              </button>
            </div>
          </div>

          {/* Input theo chế độ */}
          {inputMode === 'range' ? (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Khoảng số (từ - đến)
              </label>
              <div className="flex gap-2">
                <input 
                  type="number" 
                  placeholder="Từ số" 
                  value={fromNum} 
                  onChange={(e) => setFromNum(e.target.value)} 
                  className="flex-1 p-3 border border-gray-300 rounded-lg"
                />
                <input 
                  type="number" 
                  placeholder="Đến số" 
                  value={toNum} 
                  onChange={(e) => setToNum(e.target.value)} 
                  className="flex-1 p-3 border border-gray-300 rounded-lg"
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Ví dụ: Từ 1 đến 100 sẽ tạo 100 QR code (tối đa 1000 QR)
              </p>
              {fromNum && toNum && (
                <p className="text-sm text-[#0266B4] mt-1 font-medium">
                  Sẽ tạo {Math.max(0, parseInt(toNum) - parseInt(fromNum) + 1)} QR code
                </p>
              )}
            </div>
          ) : (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nội dung (cách nhau bởi dấu phẩy)
              </label>
              <textarea 
                placeholder="VD: Link1, Link2, Văn bản 1, Văn bản 2..." 
                value={inputData} 
                onChange={(e) => setInputData(e.target.value)} 
                className="w-full p-3 border border-gray-300 rounded-lg resize-none h-24"
                rows="4"
              />
              <p className="text-xs text-gray-500 mt-1">
                Mỗi phần tử cách nhau bởi dấu phẩy sẽ tạo 1 QR code
              </p>
            </div>
          )}

          <div className="flex gap-2 mb-4">
            <button 
              onClick={generateQRCodes}
              disabled={isGenerating || (inputMode === 'range' ? (!fromNum || !toNum) : !inputData.trim())}
              className="flex-1 bg-[#0266B4] text-white px-4 py-2 rounded-lg hover:bg-[#125e99] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {isGenerating ? "Đang tạo..." : "Tạo QR"}
            </button>
            {qrCodes.length > 0 && (
              <button 
                onClick={clearAllQR}
                className="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                <FaTrash />
              </button>
            )}
          </div>

          {/* Logo QR */}
          <button 
            onClick={() => setIsformatLogoQR(!isformatLogoQR)} 
            className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2"
          >
            <p>Logo QR</p>
            <FaChevronDown className={`transition-transform duration-300 ${isformatLogoQR ? 'rotate-180' : ''}`} />
          </button>
          
          {isformatLogoQR && (
            <div className="grid grid-cols-6 gap-2 p-2 rounded my-2 max-h-48 overflow-y-auto">
              {logoOptions.map((logo, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => handleChange("image", logo)}
                  className={`
                    flex items-center justify-center aspect-square w-12 h-12 rounded border-2
                    transition-all duration-200
                    ${settings.image === logo ? 'border-[#4AB253] ring-2 ring-[#4AB253]' : 'border-gray-200'}
                    hover:scale-105 hover:border-[#4AB253] bg-white
                  `}
                >
                  <img src={logo} alt="Logo" className="object-contain w-8 h-8" draggable={false} />
                </button>
              ))}
              <button
                type="button"
                onClick={() => handleChange("image", null)}
                className={`
                  flex items-center justify-center aspect-square w-12 h-12 rounded border-2
                  transition-all duration-200
                  ${settings.image === null ? 'border-red-500 ring-2 ring-red-400 bg-red-50' : 'border-gray-200'}
                  hover:scale-105 hover:border-red-400 bg-white
                `}
              >
                <MdOutlineImageNotSupported className="text-xl text-red-500" />
              </button>
              <button
                type="button"
                onClick={() => fileInputRef.current.click()}
                className="flex items-center justify-center aspect-square w-12 h-12 rounded border-2 border-dashed transition-all duration-200 hover:scale-105 hover:border-green-500 bg-white"
              >
                <FaPlus size={18} className="text-[#4AB253]" />
              </button>
              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                onChange={(e) => handleChange("image", URL.createObjectURL(e.target.files[0]))}
                className="hidden"
              />
            </div>
          )}

          {/* Định dạng QR */}
          <button 
            onClick={() => setIsformatStyleQR(!isformatStyleQR)} 
            className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2"
          >
            <p>Định dạng QR</p>
            <FaChevronDown className={`transition-transform duration-300 ${isformatStyleQR ? 'rotate-180' : ''}`} />
          </button>
          
          {isformatStyleQR && (
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium mb-1">Hình dạng</label>
                <select 
                  value={settings.shape} 
                  onChange={(e) => handleChange("shape", e.target.value)} 
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  <option value="square">Vuông</option>
                  <option value="circle">Tròn</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Kiểu chấm</label>
                <select 
                  value={settings.dotsOptionsType} 
                  onChange={(e) => handleChange("dotsOptionsType", e.target.value)} 
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  {valueSelectStyleQR.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Bo gốc</label>
                <select 
                  value={settings.cornersSquareOptionsType} 
                  onChange={(e) => handleChange("cornersSquareOptionsType", e.target.value)} 
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  {valueSelectStyleQR.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Chấm gốc</label>
                <select 
                  value={settings.cornersDotOptionsType} 
                  onChange={(e) => handleChange("cornersDotOptionsType", e.target.value)} 
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  {valueSelectStyleQR.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Kích thước</label>
                <div className="flex items-center gap-2">
                  <input 
                    type="range" 
                    min="200" 
                    max="600" 
                    step="50" 
                    value={settings.width} 
                    onChange={(e) => handleChange("width", e.target.value)} 
                    className="flex-1"
                  />
                  <span className="text-sm font-mono w-20 text-center">{settings.width}px</span>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className="block text-sm font-medium mb-1">Lề logo</label>
                  <input 
                    type="number" 
                    min="0" 
                    max="10" 
                    step="0.1"
                    value={settings.imageOptions_margin} 
                    onChange={(e) => handleChange("imageOptions_margin", e.target.value)} 
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Lề QR</label>
                  <input 
                    type="number" 
                    min="0" 
                    max="10" 
                    step="0.1"
                    value={settings.margin} 
                    onChange={(e) => handleChange("margin", e.target.value)} 
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </div>
              </div>
            </div>
          )}

          {/* Định dạng màu QR */}
          <button 
            onClick={() => setIsformatColorQR(!isformatColorQR)} 
            className="flex justify-between items-center w-full mt-4 px-4 py-2 bg-[#0266B4] text-white rounded hover:bg-[#125e99] my-2"
          >
            <p>Định dạng màu QR</p>
            <FaChevronDown className={`transition-transform duration-300 ${isformatColorQR ? 'rotate-180' : ''}`} />
          </button>
          
          {isformatColorQR && (
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium mb-1">Màu chấm</label>
                <div className="flex gap-2">
                  <input 
                    type="color" 
                    value={settings.dotsOptionsColor} 
                    onChange={(e) => handleChange("dotsOptionsColor", e.target.value)} 
                    className="w-16 h-10 border border-gray-300 rounded"
                  />
                  <input 
                    type="text" 
                    placeholder="#000000" 
                    value={settings.dotsOptionsColor} 
                    onChange={(e) => handleChange("dotsOptionsColor", e.target.value)} 
                    className="flex-1 p-2 border border-gray-300 rounded"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Màu nền</label>
                <div className="flex gap-2">
                  <input 
                    type="color" 
                    value={settings.backgroundOptionsColor} 
                    onChange={(e) => handleChange("backgroundOptionsColor", e.target.value)} 
                    className="w-16 h-10 border border-gray-300 rounded"
                  />
                  <input 
                    type="text" 
                    placeholder="#ffffff" 
                    value={settings.backgroundOptionsColor} 
                    onChange={(e) => handleChange("backgroundOptionsColor", e.target.value)} 
                    className="flex-1 p-2 border border-gray-300 rounded"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Màu bo gốc</label>
                <div className="flex gap-2">
                  <input 
                    type="color" 
                    value={settings.cornersSquareOptionsColor} 
                    onChange={(e) => handleChange("cornersSquareOptionsColor", e.target.value)} 
                    className="w-16 h-10 border border-gray-300 rounded"
                  />
                  <input 
                    type="text" 
                    placeholder="#000000" 
                    value={settings.cornersSquareOptionsColor} 
                    onChange={(e) => handleChange("cornersSquareOptionsColor", e.target.value)} 
                    className="flex-1 p-2 border border-gray-300 rounded"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">Màu chấm gốc</label>
                <div className="flex gap-2">
                  <input 
                    type="color" 
                    value={settings.cornersDotOptionsColor} 
                    onChange={(e) => handleChange("cornersDotOptionsColor", e.target.value)} 
                    className="w-16 h-10 border border-gray-300 rounded"
                  />
                  <input 
                    type="text" 
                    placeholder="#000000" 
                    value={settings.cornersDotOptionsColor} 
                    onChange={(e) => handleChange("cornersDotOptionsColor", e.target.value)} 
                    className="flex-1 p-2 border border-gray-300 rounded"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-between mt-6">
            <button 
              onClick={() => {
                localStorage.removeItem("multiQrSettings"); 
                window.location.reload();
              }} 
              className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded transition-colors"
            >
              <RiResetLeftFill />
            </button>
            
            {qrCodes.length > 0 && (
              <button 
                onClick={downloadAllQR}
                className="flex items-center gap-2 px-4 py-2 bg-[#4AB253] text-white rounded hover:bg-[#44a74c] transition-colors"
              >
                <FaDownload />
                Tải ZIP ({qrCodes.length})
              </button>
            )}
          </div>
        </div>

        {/* Cột bên phải - Hiển thị QR codes */}
        <div className="lg:w-2/3 bg-white p-6 rounded-lg shadow-md">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">
              Danh sách QR codes {qrCodes.length > 0 && `(${qrCodes.length})`}
            </h2>
          </div>
          
          <div 
            ref={qrContainerRef}
            className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 max-h-96 overflow-y-auto"
            style={{ minHeight: qrCodes.length === 0 ? "200px" : "auto" }}
          >
            {qrCodes.length === 0 && (
              <div className="col-span-full flex flex-col items-center justify-center py-16 text-gray-500">
                <div className="text-4xl mb-4">📱</div>
                <p className="text-lg font-medium">Chưa có QR code nào</p>
                <p className="text-sm">Nhập nội dung và nhấn "Tạo QR" để bắt đầu</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
